var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-snackbar',{style:(_vm.css),attrs:{"md-position":"center","md-active":_vm.show,"md-persistent":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }